import { msg } from '@lingui/core/macro';
import { createDevice } from 'modules/devices/store/actions';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store/hooks';
import { useToastApiError } from 'shared/hooks/use-toast-api-error';

export function useCreateDevice(tournamentId: number | null, refetch: () => void) {
  const { t } = useLingui();
  const toastApiError = useToastApiError();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (params: { name: string }) => {
      if (!tournamentId) return;
      setIsLoading(true);
      try {
        await dispatch(createDevice({ name: params.name, tournament_id: tournamentId })).unwrap();
        toast.success(t`Устройство создано`);
        refetch();
      } catch (error) {
        toastApiError(error, msg`Не удалось создать устройство`);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, tournamentId, refetch, t, toastApiError],
  );

  return { mutate, isLoading };
}
